<pcs-icon [icon]="icon" size="iconXXL" class="mb-2"></pcs-icon>
<p>{{ message | translate }}</p>
